import { Category } from "types"

export const getCategoryByParentName = (
  categories: Category[],
  name?: string
) => {
  // find category by parent name
  const categoryByParentName = categories.find(
    category => category?.wpParent?.node.name === name
  )

  // find category by name
  const categoryWithParent = categories.find(
    category => category?.name === name
  )

  // first array element
  const categoryDefault = categories[0]

  return categoryByParentName ?? categoryWithParent ?? categoryDefault
}
